<template>
	<svg :width="width" :height="height" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<!-- black inner circle -->
		<circle cx="12" cy="12" r="10" fill="black" />
		
		<g clip-path="url(#clip0_9942_3750)">
			<path
				d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM6.5 9L10 5.5L13.5 9H11V13H9V9H6.5ZM17.5 15L14 18.5L10.5 15H13V11H15V15H17.5Z"
				:fill="color" />
		</g>
		<defs>
			<clipPath id="clip0_9942_3750">
				<rect width="24" height="24" fill="black" />
			</clipPath>
		</defs>
	</svg>
</template>

<script>
import { extractValueAndUnit } from '../../utils/iconUtils'

export default {

	name: 'IconSwapVerticalCircle',

	props: {
		sizeMultiplier_prop: {
			type: Number,
			default: 1,
		},

		width_prop: {
			type: String,
			default: '1rem', // "px" or "em" only
		},

		height_prop: {
			type: String,
			default: '1rem', // "px" or "em" only
		},

		color_prop: {
			type: String,
			default: '',
		},
	},

	data() {
		return {
		}
	},

	computed: {
		color() {
			return this.color_prop || getComputedStyle(document.documentElement).getPropertyValue('--color-theme')
		},

		width() {
			const { value, unit } = extractValueAndUnit(this.width_prop)
			return `${value * this.sizeMultiplier_prop}${unit}`
		},

		height() {
			const { value, unit } = extractValueAndUnit(this.height_prop)
			return `${value * this.sizeMultiplier_prop}${unit}`
		},
	},
}
</script>